import React, { useEffect, useState } from 'react'
import Modal from 'react-bootstrap/Modal';
import LottiePlayer from "lottie-react";
import { CloseIcon, FolderIcon } from '../../Static/icons/iconshere';
import NoDataFoundAnim from "../../animations/nodatafound.json"

const AssetLinkCategoryModal = ({moduleTitle, showLinkModel, handleCloseLinkModal, threeDCategoryList, handleClickCategory, hierarchyList, linkedCategory, setLinkedCategory }) => {
 
    const [newSelectCategory, setNewSelectCategory] = useState({
        id:null,
        name: null
    })

    const handleSelectCategory = (e,item) =>{
        e.stopPropagation();
        setNewSelectCategory({
            id: item.id,
            name: item.name,
        });
    }

    const handleSaveLinkModal = () =>{
        setLinkedCategory(newSelectCategory);
        handleCloseLinkModal(false);
    }
 
    useEffect(()=>{
        setNewSelectCategory(linkedCategory);
    },[linkedCategory])

    return (
     <>
        <Modal show={showLinkModel} size="xl" className='moving-box' centered  onHide={()=>handleCloseLinkModal(false)}>
            <Modal.Header className="modalheader">
                Select Category for "{moduleTitle}"
                <span onClick={()=>handleCloseLinkModal(false)}>
                    <CloseIcon />
                </span>
            </Modal.Header>

            <Modal.Body className='pt-0'>
                    <div className='group-breadcrumbs pt-2'>
                        {hierarchyList.map((item,index)=>{
                            return(
                            <>
                                <div className='group-breadcrumbs-item' onClick={()=>handleClickCategory(item.id)}> {item.name} </div>
                                <div className='separate'> &gt; </div>
                                </>
                            )
                        })}
                    </div>

                    <div className={'model-list'}>
                            {threeDCategoryList.length === 0 ?
                                <>
                                    <div className='no-group-found'>
                                        <LottiePlayer
                                            animationData={NoDataFoundAnim}
                                            style={{ height: 100, marginBottom: 0 }}
                                        />
                                        <p>No Category Found</p>
                                    </div>
                                </>
                            :
                        <div className='model-list-here'>
                            {threeDCategoryList.map((item)=>{
                                return(
                                    <>
                                        <div className='folder-path' key={item.id} onClick={()=>handleClickCategory(item.id)}>
                                        {/* <input type="checkbox" name="category" checked={newSelectCategory.id === item.id} value={item.id} onClick={(e) => e.stopPropagation()} onChange={(e) =>handleSelectCategory(e,item)} className='radio-button' /> */}
                                            <FolderIcon />
                                            <p className='name'>
                                                {item.name}
                                            </p>
                                            <div className="form-check listchild">
                                                <input checked={newSelectCategory.id === item.id} className="form-check-input" name="basicDetails" onClick={(e) => e.stopPropagation()} onChange={(e) =>handleSelectCategory(e,item)} type="checkbox" id={item.id} />
                                                <label className="form-check-label" htmlFor={item.id}>
                                                </label>
                                            </div>
                                        </div> 
                                    </>
                                )
                            })}
                            </div>
                            }                             
                    </div>            
                    {newSelectCategory.id && 
                        <div className='selected-items'>
                                <p>Select Category:</p>
                                <div className='list-here'>
                                    <span className='selectedlist' onClick={()=>setNewSelectCategory({id: null, name: null})}>
                                        <span className='select-item'>
                                            {newSelectCategory.name} 
                                            <span className='close'>
                                                <CloseIcon/>
                                            </span>
                                        </span>
                                    </span>
                                </div>
                        </div>
                    }
                    <div className='modal-footer-btn mt-3 pt-2 mb-3 justify-content-between mb-0'>
                        <span className='text-success text-bold' style={{ fontSize: "0.85rem" }}> {""} </span>
                        <div className='d-flex align-items-center gap-2 justify-content-end'>
                            <button className='createbtn cancelbtn' onClick={()=>handleCloseLinkModal(false)}>
                                Cancel
                            </button>
                            <button className='createbtn' onClick={()=>handleSaveLinkModal(true)}>
                                Save
                            </button>
                        </div>
                    </div>
            </Modal.Body>
        </Modal>
    
     </>
  )
}


export default AssetLinkCategoryModal;